// extracted by mini-css-extract-plugin
export default {"colorBannerText":"#1a1a1a"};